import apiClient from "./apiClient";

export const MaxNotesLength = 250;

export const AreNotesLessThanMaxLength = (notes = []) => {
    let invalidItems = []
    notes.forEach(n => {
        let isNotesValid = true
        isNotesValid = (n.note?.length ?? 0) < MaxNotesLength;
        if (!isNotesValid) {
            invalidItems.push(n?.name)
        }
    })
    return invalidItems;
}

 export const ToCamelCase = (name) => {
    let camelCase = name.charAt(0).toUpperCase() + name.slice(1);

    if (camelCase === 'Liner') {
      camelCase += 's';
    } else if (camelCase === 'Foot') {
      camelCase = 'Feet'
    }

    return camelCase;
  }

export const GetAccountPermission = async (accountNumber, permissionName) => {
  const permissions = await apiClient.get("permission/" + accountNumber);
  let hasPermission = false;
  if (permissions?.data?.length > 0) {
    hasPermission = permissions?.data.some((permission) => {
      return permission.permissionName === permissionName
    })
  }
  return hasPermission;
}